@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.itn-warning {
  background-color: var(--gold-200);
  display: flex;
  align-items: center;
  padding: 5px;
}

.icon-container {
  margin: 0 5px;
}

.icon {
  height: 16px;
  fill: var(--gold-500);
}
